import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle';

import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';
import 'lightgallery/modules/lg-video.js';

import './js/components/gallery';
import './js/components/faq';
import './js/components/contact-form';
import './js/components/header';
import './js/components/theme-slider';
import './js/components/blog';
import './js/globals';
import './js/details';
import './js/details-camps';
import './js/booking';
import './js/list-travel';
import './js/list-activities';

import lozad from 'lozad';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

